export default "__VITE_ASSET__33ec403d__"